import {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';

import { CircularProgress, TextField, DialogContent } from '@mui/material';
import { CustomizedModal } from 'js/containers/Dialog/CustomizedModal';
import { Close } from '@mui/icons-material';
import { hexToRgb } from 'js/library/utils/helpers';

import { validateCode } from 'js/library/utils/API/validateSMS.js';

import { toast } from 'react-toastify';

import './stylesDataConfirmation.css';

export function ModalValidationCode(props) {

    const { t } = useTranslation('app');

    const [validationCode, setValidationCode] = useState('');
    const [messageError, setMessageError] = useState('');
    const [startTime, setStartTime] = useState(false);
    const [resetTime, setResetTime] = useState(false);
    const [hover, setHover] = useState(false);
    const rgbaColor = props.clubeInfo && props.clubeInfo.colorPrimary 
    ? 'rgba(' + hexToRgb(props.clubeInfo.colorPrimary).r + ',' + hexToRgb(props.clubeInfo.colorPrimary).g +', ' + hexToRgb(props.clubeInfo.colorPrimary).b + ', 0.2)'
    : null;

    useEffect(() => {
        setValidationCode('');
        setMessageError('');
        setStartTime(false);
    }, []);

    function validationSMS(event) {
        event.preventDefault();
        props.setLoading(true);

		validateCode(validationCode, props.userCellphone, props.transactionId).then((result) => {
            
            if (result.data.success) { 
                if(props.typeAction === 'atualizar'){
                    props.addUserData(props.typeAction);
                }else{
                    props.toggleModal();
                    props.setIsOpenModal(true);
                    props.setLoading(false);
                }
			}
			else {
                toast.error(t('errors.error_ocurred'));
                setMessageError('');
                props.setLoading(false);  
			}
		}).catch((error) => {
            props.setLoading(false);  

            if (error.response.status === 422) {
                toast.warning(t('errors.invalid_code'));
                setMessageError(t('errors.invalid_code'));
            }
            else {
                toast.error(t('errors.error_ocurred'));
                setMessageError('');
            }
		});
	}

    function handleChangeInput(event) {
        const {value} = event.target;
        setMessageError('');

		if (value.length < 7) {
            setValidationCode(value);
		}
	}

    useEffect(() => {
        const time = setTimeout(() => {setStartTime(true); setResetTime(false);}, 17000);

        return () => {
            setStartTime(false);
            clearTimeout(time);
        };
    }, [resetTime]);
   
    return(
        <CustomizedModal
            open={props.open}
            keepMounted
            onClose={props.loading03 ? null : props.toggleModal}
        >
            <DialogContent className='content-modal-delete-data'>
                <header className="header-modal-delete-data">
                    <strong>{ t('general.authentication_code') }</strong>
                    <Close style={props.clubeInfo ? { color: props.clubeInfo.colorPrimary } : {}} onClick={() => { if(!props.loading03) props.toggleModal(); } }/>
                </header>

                <form style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} onSubmit={validationSMS}>
                <main className="main-modal-delete-data">
                    <p>{ t('general.you_will_receive_auth_code_in_seconds') }</p>
                    <p style={{ fontSize: '13px' }}>{ t('general.authentication_code_sent_to') } {props.userCellphone}</p>
                    {
                        messageError !== '' && <span style={{ color: 'red', fontSize: '12px', marginBottom: '10px'}}>{messageError}</span>
                    }

                    <TextField
                        color="secondary"
                        fullWidth 
                        autoFocus 
                        required 
                        autoComplete="off" 
                        value={validationCode}
                        onChange={(event) => handleChangeInput(event)} 
                        type="tel" 
                        id="code" 
                        label="Código" 
                    />
                
                </main>

                <div className='area-button-modal-delete-data-02'>
                    <button disabled={validationCode.length < 6 || props.loading03} className={`${validationCode.length < 6 ? 'button-modal-delete-data disabled-button-modal-validation' : 'button-modal-delete-data' }`} type='submit' style={ props.clubeInfo ? { background: props.clubeInfo.colorPrimary} : {} }>
                        {props.loading03 ? <CircularProgress style={{ color: '#fff' }} size={20}/> : t('general.confirm')}
                    </button>

                    { startTime && !props.loading03 &&
                        <button disabled={props.loading02} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} className='button-modal-delete-data-02' onClick={() => {props.sendCode(); setResetTime(!resetTime); setStartTime(false);}} type='button' style={props.clubeInfo ? hover ? { borderColor: props.clubeInfo.colorPrimary, backgroundColor: rgbaColor } : { borderColor: props.clubeInfo.colorPrimary } : {}}>
                            {props.loading02 ? <CircularProgress style={{ color: props.clubeInfo ? props.clubeInfo.colorPrimary : '#6d3196' }} size={20}/> : 
                             <span style={props.clubeInfo ? { color: props.clubeInfo.colorPrimary } : { color: '#6d3196' }}>{ t('general.send_authentication_code_again') }</span>
                            }
                        </button>
                    } 

                </div>
                </ form>
            </DialogContent>
        </CustomizedModal>
    );
} 